import React from "react";
import { HashLoader } from "react-spinners";
// import PropTypes from "prop-types";

const Loader = (props) => {
  const { isLoading } = props;

  return isLoading ? (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-white/30 transition-all duration-500">
      <div className="bg-white p-8 rounded-2xl shadow-md">
        <div className="flex flex-col items-center space-y-3">
          <HashLoader 
            loading={isLoading} 
            size={40} 
            color="#64748b"
            className="animate-[spin_2s_ease-in-out_infinite]"
          />
          <p className="text-slate-500 font-light">Please wait...</p>
        </div>
      </div>
    </div>
  ) : null;
};

// Loader.propTypes = {
//   isLoading: PropTypes.bool,
// };

export default Loader;
